type LoadStateProps = {
  /** Texto anunciado a lectores de pantalla y mostrado junto al indicador. */
  label?: string
  /** Variante en línea (cabeceras, selectores): sin padding vertical grande y en texto pequeño. */
  compact?: boolean
  className?: string
}

/**
 * Estado de carga único del back-office: mismo texto, mismo contraste (gray-500, AA sobre blanco)
 * y mismo `role="status"` en todas las pantallas. Reemplaza los "Cargando..." sueltos.
 */
export function LoadState({ label = "Cargando...", compact = false, className = "" }: LoadStateProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={`flex items-center justify-center gap-2 text-gray-500 dark:text-gray-400 ${compact ? "py-1 text-xs" : "px-4 py-8 text-sm"} ${className}`}
    >
      <svg className="size-4 shrink-0 motion-safe:animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.5" strokeOpacity="0.25" />
        <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
      {label}
    </div>
  )
}

export default LoadState
